import { render } from "./GenerateMissingSB.vue?vue&type=template&id=7af10130&scoped=true"
import script from "./GenerateMissingSB.vue?vue&type=script&lang=js"
export * from "./GenerateMissingSB.vue?vue&type=script&lang=js"

import "./GenerateMissingSB.vue?vue&type=style&index=0&id=7af10130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af10130"]])

export default __exports__